import React from 'react';
import { Box, IconButton } from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';
import { FormProvider, useWatch } from 'react-hook-form';
import { RHFTextField } from '../../RHF';
import { MessageFormData } from '../validationSchemas';

interface ChatInputProps {
  formMethods: any; // FormProvider methods
  isPending: boolean;
  onSubmit: (data: MessageFormData) => void;
  onKeyPress: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

const ChatInput: React.FC<ChatInputProps> = ({
  formMethods,
  isPending,
  onSubmit,
  onKeyPress,
}) => {
  const messageValue = useWatch({
    control: formMethods.control,
    name: 'message',
    defaultValue: '',
  });
  const isSendDisabled = isPending || !String(messageValue || '').trim();

  const messageFieldSx = {
    '& .MuiOutlinedInput-root': {
      minHeight: '44px',
      height: 'auto',
      borderRadius: '12px',
      alignItems: 'flex-start',
      padding: '11px 12px',
      '& .MuiOutlinedInput-notchedOutline': {
        borderRadius: '12px',
      },
      '& textarea': {
        padding: '0',
        lineHeight: '20px',
        minHeight: '20px !important',
        overflow: 'auto !important',
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '0',
      height: 'auto',
      boxSizing: 'border-box',
    },
    '& .MuiInputBase-inputMultiline': {
      padding: '0 !important',
    },
  };

  return (
    <Box className="chat-input">
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(onSubmit)} className="message-form">
          <RHFTextField
            name="message"
            placeholder={isPending ? "Sending message..." : "Type your message..."}
            className="message-field"
            multiline
            minRows={1}
            maxRows={3}
            disabled={isPending}
            onKeyDown={onKeyPress}
            sx={messageFieldSx}
          />
          <IconButton
            type="submit"
            disabled={isSendDisabled}
            className="send-button"
            title={isPending ? "Sending message..." : "Send message"}
          >
            <SendIcon />
          </IconButton>
        </form>
      </FormProvider>
    </Box>
  );
};

export default ChatInput;
